import React, { useState, useContext, useCallback, useEffect } from "react";
import { Form, UPDATE_FILTERS_DATA } from "@components";
import { LandingZoneRoleModel } from "@api/types/landingzoneroles";
import { TableContext } from "../table";
import { LandingZoneRoleDetail } from "../../../screens/dashboard/admin/maintenance/landingzoneroles/detail";
import { Box, Grid } from "@material-ui/core";
import { Actions } from "../../../screens/request/components/actions";
import { Search } from "./search-filters";

export const LandingZoneRolesToolbar: React.FC = () => {
  const [openLandingZoneRole, setOpenLandingZoneRole] = useState<boolean>(
    false
  );
  const { dispatch } = useContext(TableContext);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  const form = Form.useManager<LandingZoneRoleModel>({
    id: 0,
    landingZoneRoleName: "",
    isActive: false,
  });

  useEffect(() => {
    if (!openLandingZoneRole) {
      form.reset();
    }
  }, [openLandingZoneRole]);

  function handleClickOpen() {
    setOpenLandingZoneRole(true);
  }

  const isShowModal = openLandingZoneRole ? (
    <LandingZoneRoleDetail
      form={form}
      open={openLandingZoneRole}
      onCancel={() => setOpenLandingZoneRole(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Landing Zone Role
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Name"}
          ></Search>
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
